import { useLoaderData } from 'react-router';

import {
    DetailBreadcrumbBar,
    detailStatsFromProfileKpi,
} from '~/ui-rocco/pages/detail-shared';
import type { loader } from '~/routes/_app.product.$urlSegment';
import { useProductDetailItems } from './spec-accordion/use-product-detail-items';

/**
 * The category trail, directly under the gallery.
 *
 * It used to open the spec list on the right of the details section, where it
 * read as a heading for the Description rather than as the page's place in the
 * catalogue. Under the gallery it sits at the page gutter, where a reader
 * looks to find out where they are. The supplier's profile views and saves
 * share its line.
 */
export const ProductBreadcrumbBar = ({
    withStats = true,
}: {
    /**
     * The phone order passes false: there the supplier's views and saves
     * live in the trust row under the name they describe, and the trail is
     * pure wayfinding — an unlabelled count beside a product trail read as
     * the product's own.
     */
    withStats?: boolean;
}) => {
    const { product } = useLoaderData<typeof loader>();
    const { breadcrumb } = useProductDetailItems();

    return (
        <DetailBreadcrumbBar
            trail={breadcrumb}
            // The mobile pb opens a step between the trail and the Tags
            // label under it — without it the two lines touched and the
            // trail read as a stray heading rather than the block's
            // address line.
            className="bg-ground max-md:pb-4"
            stats={
                withStats
                    ? detailStatsFromProfileKpi(
                          product.Professional.AggregatedPublicKPI,
                      )
                    : undefined
            }
        />
    );
};
